import { render, staticRenderFns } from "./DokmanComponentLenkungPruefung.vue?vue&type=template&id=894eee74&scoped=true"
import script from "./DokmanComponentLenkungPruefung.vue?vue&type=script&lang=js"
export * from "./DokmanComponentLenkungPruefung.vue?vue&type=script&lang=js"
import style0 from "./DokmanComponentLenkungPruefung.vue?vue&type=style&index=0&id=894eee74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894eee74",
  null
  
)

export default component.exports